import { useCallback, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type CreateSalePayload = {
  items: Array<{ product_id: string | number; quantity: number }>;
  customer_name: string;
  customer_phone: string;
  payment_method: "cash" | "razorpay" | "gpay" | "upi";
  promo_code?: string | null;
};

export function useCreateSale() {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createSale = useCallback(
    async (payload: CreateSalePayload) => {
      if (!token) throw new Error("Not authenticated");
      setLoading(true);
      setError(null);
      try {
        return await api.sales.create({ token, payload });
      } catch (e) {
        setError(e instanceof Error ? e.message : "Failed to create sale");
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [token],
  );

  return { createSale, loading, error };
}

